import React, { useEffect, useState } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import EditModal from "./shared/EditModal";

export default function ExperienceSection({ value = [], onChange, onYearsChange }) {
  const [items, setItems] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);
  const [experience, setExperience] = useState({ years: "", months: "" });
  const [formData, setFormData] = useState({});

  useEffect(() => setItems(value || []), [value]);

  const yearsOptions = generateYears();
  const yearRange = Array.from({ length: 41 }, (_, i) => i); // 0–40 years
  const monthRange = Array.from({ length: 12 }, (_, i) => i); // 0–11 months

  function generateYears() {
    const cur = new Date().getFullYear();
    const arr = [];
    for (let y = cur; y >= 1980; y--) arr.push(String(y));
    return arr;
  }

  const openAdd = () => {
    if (items.length >= 3) {
      alert("You can add a maximum of 3 companies.");
      return;
    }
    setEditIdx(null);
    setFormData({ company: "", role: "", startYear: "", endYear: "", present: false });
    setOpen(true);
  };

  const openEdit = (i) => {
    setEditIdx(i);
    setFormData(items[i]);
    setOpen(true);
  };

  const save = (obj) => {
    const next = [...items];
    if (editIdx == null) next.push(obj);
    else next[editIdx] = obj;
    setItems(next);
    onChange(next);
    setOpen(false);
  };

  const remove = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    setItems(next);
    onChange(next);
  };

  // 🔹 Handle combined years & months selection
  const handleExperienceChange = (type, val) => {
    const next = { ...experience, [type]: val };
    setExperience(next);

    // convert to total months (for easier use in parent)
    const totalMonths = (parseInt(next.years));
    onYearsChange(totalMonths ); // sends total years (can be fractional)
  };

  // 👇 Automatically hide "End Year" when present = true
  const fields = [
    { name: "company", label: "Company Name", type: "text" },
    { name: "role", label: "Designation", type: "text" },
    { name: "startYear", label: "Start Year", type: "select", options: yearsOptions },
    {
      name: "present",
      label: "Currently Working Here",
      type: "checkbox",
      onChange: (checked) => setFormData({ ...formData, present: checked }),
    },
    ...(formData.present
      ? []
      : [{ name: "endYear", label: "End Year", type: "select", options: yearsOptions }]),
  ];

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Experience</h3>
        <div className="card-actions">
          <button className="link" onClick={openAdd}>
            Add
          </button>
        </div>
      </div>

      <div className="card-body">
        {/* Total Years of Experience */}
        <div className="form-group" style={{ display: "flex", gap: "10px"}}>
          <label style={{ minWidth: "200px" }}>Total Years of Experience:</label>
         <div className="experience-selects">
          <select
            value={experience.years}
            onChange={(e) => handleExperienceChange("years", e.target.value)}
          >
            <option value="">Years</option>
            {yearRange.map((y) => (
              <option key={y} value={y}>
                {y} {y === 1 ? "year" : "years"}
              </option>
            ))}
          </select>

          <select
            value={experience.months}
            onChange={(e) => handleExperienceChange("months", e.target.value)}
          >
            <option value="">Months</option>
            {monthRange.map((m) => (
              <option key={m} value={m}>
                {m} {m === 1 ? "month" : "months"}
              </option>
            ))}
          </select>
          </div>
        </div>

        {/* Experience List */}
        {items.length === 0 ? (
          <p className="muted">No experienced details added yet</p>
        ) : (
          items.map((it, i) => (
            <div className="item-row" key={i}>
              <div>
                <div className="item-title">
                  {it.company} — {it.role}
                </div>
                <div className="muted">
                  {it.startYear} — {it.present ? "Present" : it.endYear || ""}
                </div>
              </div>
              <div className="item-actions">
                <MdEdit title="Edit" className="smalll" onClick={() => openEdit(i)} />
                <MdDelete title="Delete" className="smalll danger" onClick={() => remove(i)} />
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {open && (
        <EditModal
          title={editIdx == null ? "Add Experience" : "Edit Experience"}
          initial={formData}
          fields={fields}
          onClose={() => setOpen(false)}
          onSave={save}
        />
      )}
    </section>
  );
}
